import { ConfigurationTenantsService_tenantsServiceGetGetRegisteredTenants } from '@festina/collcalc-general-types/collcalc/hooks/ConfigurationTenantsService_tenantsServiceGetGetRegisteredTenants'

export const useFetchCollCalcTenants =
  ConfigurationTenantsService_tenantsServiceGetGetRegisteredTenants.useSuspenseQuery
